"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hooks_1 = require("preact/hooks");
var preact_1 = require("preact");
var config_1 = require("../constants/config");
function Login() {
  var loginUrl = (0, hooks_1.useMemo)(function () {
    return "".concat(config_1.LOGIN_DOMAIN, "/afreeca/login.php?szFrom=full&request_uri=").concat(encodeURIComponent(location.href));
  }, []);
  var handleGoLogin = function handleGoLogin() {
    document.location.href = "".concat(loginUrl);
  };
  return (0, preact_1.h)("div", {
    id: "NotLogin",
    className: "serviceLogin"
  }, (0, preact_1.h)("div", {
    className: "inner"
  }, (0, preact_1.h)("div", {
    className: "text"
  }, (0, preact_1.h)("em", {
    onclick: handleGoLogin
  }, "\uB85C\uADF8\uC778 \uD558\uAE30"), "\uB85C\uADF8\uC778 \uD558\uC2DC\uBA74 \uC990\uACA8\uCC3E\uB294 \uC2A4\uD2B8\uB9AC\uBA38\uC758 LIVE\uAC00 \uC2DC\uC791\uD558\uAC70\uB098", (0, preact_1.h)("br", null), "\uC0C8 \uAE00\uC774 \uC62C\uB77C\uC624\uBA74 \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.")));
}
exports.default = Login;